import styles from '../RmCard.module.scss';
import PropTypes from 'prop-types';

const AlertsTooltip = (props) => {
    const { data, breachCategory } = props;
    return (
        <>
            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>CTO Code</span>
                <span className={styles.statsValue}>{data.rmEmployeeId}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Team</span>
                <span className={styles.statsValue}>{data.rmGroup}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Market</span>
                <span className={styles.statsValue}>{data.rmRegion}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>S2 Rank</span>
                <span className={styles.statsValue}>{data.rank}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>S2 Risk Score</span>
                <span className={styles.statsValue}>{data.score}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>Breach Category</span>
                <span className={styles.statsValue}>{breachCategory}</span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}>% of Alerts</span>
                <span className={styles.statsValue}>
                    {`${data.percentAlerts.toFixed(1)}%`}
                </span>
            </div>

            <div className={styles.textContainer}>
                <span className={styles.statsTitle}># of Alerts</span>
                <span className={styles.statsValue}>{data.totalAlerts}</span>
            </div>
        </>
    );
};

AlertsTooltip.propTypes = {
    data: PropTypes.shape({
        rmEmployeeId: PropTypes.string,
        totalAlerts: PropTypes.number,
        percentAlerts: PropTypes.number,
        rank: PropTypes.number,
        score: PropTypes.number,
        rmRegion: PropTypes.string,
        rmGroup: PropTypes.string
    }),
    breachCategory: PropTypes.string
};

export default AlertsTooltip;
